/* eslint-disable */
const state = {
  loading: null,
  breadcrumbs: [],
  pageTitle: "",
  pageSubtitle: ""
};

// getters
const getters = {};

// actions
const actions = {
  setLoading: (context, value) => {
    context.commit("SET_LOADING", value);
  },
  setBreadcrumbs: (context, value) => {
    context.commit("SET_BREADCRUMBS", value);
  },
  setPageTitle: (context, value) => {
    context.commit("SET_PAGE_TITLE", value);
  },
  setPageSubTitle: (context, value) => {
    context.commit("SET_PAGE_TITLE", value);
  },
  setTitles: (context, payload) => {
    context.commit("SET_PAGE_TITLE", payload.title || "");
    context.commit("SET_PAGE_SUBTITLE", payload.subtitle || "");
  }
};

// mutations
const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_BREADCRUMBS(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs;
  },
  SET_PAGE_TITLE(state, pageTitle) {
    state.pageTitle = pageTitle;
  },
  SET_PAGE_SUBTITLE(state, pageSubtitle) {
    state.pageSubtitle = pageSubtitle;
  }
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};
